import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import LocalidadesTab from '../components/LocalidadesTab';
import '../components/Dashboard.css';

const LocalidadesPage = () => {
    const navigate = useNavigate();
    const municipioId = localStorage.getItem('user_municipio_id');

    React.useEffect(() => {
        if (!municipioId) navigate('/');
    }, [municipioId, navigate]);

    if (!municipioId) return null;

    return (
        <div className="portal-layout">
            <Header activeView="localidades" />
            <main className="main-content">
                <div className="content-container">
                    <div className="tab-header-container">
                        <div className="tab-title-group">
                            <h1 className="tab-title-main">Localidades</h1>
                            <p className="tab-subtitle-main">Referencial geográfico — cadastro e gestão das localidades do município.</p>
                        </div>
                    </div>
                    <LocalidadesTab municipioId={municipioId} />
                </div>
            </main>
        </div>
    );
};

export default LocalidadesPage;
